export default {
  // deprecated
  googleRedirectUri: "https://clinic-mol-front-sisprod.quark.tec.br",
  baseUrl: "https://api-clinic-sisprod.quark.tec.br/mol/api/",
  vueAuth: "/api/social",
  google: {
    // XXX: a ser depreciado
    clientId: "681146735072-osvebcsnu3k48gee5asq0ojf3dn4qsd3.apps.googleusercontent.com",
    // novo clientId
    // clientId: "72459285399-oeeq046eeh32iee4a49ah64ksb1vgdjc.apps.googleusercontent.com",
    redirectUri: "https://clinic-mol-front-sisprod.quark.tec.br",
  },
  facebook: {
    clientId: "2198927940197076",
    redirectUri: "https://clinic-mol-front-sisprod.quark.tec.br/oauth",
  },
};
